import React from "react";
import TotalIcon from "../../../assets/dashboard/dr_total_report.svg";
import OpenIcon from "../../../assets/dashboard/drsecure_open.svg";
import ReceiveIcon from "../../../assets/dashboard/dr_receive.svg";
import ClosedIcon from "../../../assets/dashboard/ifeedback_close.svg";
import DuplicateIcon from "../../../assets/dashboard/dr_duplicat.svg";
import { BarChartComponents } from "../components/barChart";
import { DrSecureBarGraphConfig } from "./configData";
import { Loader } from "@progress/kendo-react-indicators";
import { NoRecord } from "../components/noRecord";
import { Upcoming } from "../components/upcoming";
import { NoPermission } from "../components/noPermission";

export const DashboardDRSecure = (props) => {
  return (
    <div>
      <div className="dashboard_graph_title_box">
        <div className="dashboard_graph_title">DR Secure Reported Incident</div>
      </div>
      {props.permission ? (
        props.loading ? (
          <Loader
            type="converging-spinner"
            style={{
              width: "100%",
              minHeight: "600px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        ) : (
          <div className="dahsboard_drsecure_main_box">
            <div className="dahsboard_drsecure_first_box">
              <div className="dahsboard_drsecure_first_box_first_child">
                <div className="dashboard_drsecure_first_box_first_child_detail">
                  <div>
                    <img src={TotalIcon} />
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_text">
                    Total Incidents Reported
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_count">
                    {props.data && props.data.total_secure_reports
                      ? props.data.total_secure_reports
                      : 0}
                  </div>
                </div>
                <div className="dashboard_drsecure_first_box_first_child_detail">
                  <div>
                    <img src={OpenIcon} />
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_text">
                    Open
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_count">
                    {props.data && props.data.secure_open_reports
                      ? props.data.secure_open_reports
                      : 0}
                  </div>
                </div>
                <div className="dashboard_drsecure_first_box_first_child_detail">
                  <div>
                    <img src={ReceiveIcon} />
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_text">
                    Received
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_count">
                    {props.data && props.data.secure_received_reports
                      ? props.data.secure_received_reports
                      : 0}
                  </div>
                </div>
                <div className="dashboard_drsecure_first_box_first_child_detail">
                  <div>
                    <img src={ClosedIcon} />
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_text">
                    Closed
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_count">
                    {props.data && props.data.secure_closed_reports
                      ? props.data.secure_closed_reports
                      : 0}
                  </div>
                </div>
                <div className="dashboard_drsecure_first_box_first_child_detail">
                  <div>
                    <img src={DuplicateIcon} />
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_text">
                    Duplicated
                  </div>
                  <div className="dashboard_drsecure_first_box_first_child_detail_count">
                    {props.data && props.data.secure_duplicated_reports
                      ? props.data.secure_duplicated_reports
                      : 0}
                  </div>
                </div>
              </div>
              <div className="dahsboard_drsecure_first_box_last_child">
                {props.data &&
                props.data.secure_incident_type_groupby &&
                props.data.secure_incident_type_groupby.length > 0 ? (
                  <BarChartComponents
                    data={
                      props.data &&
                      props.data.secure_incident_type_groupby &&
                      props.data.secure_incident_type_groupby.length > 0
                        ? props.data.secure_incident_type_groupby
                        : []
                    }
                    config={DrSecureBarGraphConfig}
                  />
                ) : (
                  <NoRecord />
                )}
              </div>
            </div>
            <div className="dahsboard_drsecure_second_box">
              <div className="dashboard_graph_title_box">
                <div className="dahsboard_drsecure_second_box_title">
                  Submissions by Department
                </div>
                <div
                  className="dashboard_drsecure_see_all_button"
                  onClick={() =>
                    props.handleNavigate &&
                    props.handleNavigate(
                      props.route ? props.route : "/dashboard"
                    )
                  }
                >
                  See all
                </div>
              </div>
              <div className="dashboard_drsecure_second_item_box_child">
                {props.data &&
                props.data.secure_submission_dept &&
                props.data.secure_submission_dept.length > 0 ? (
                  props.data.secure_submission_dept
                    .slice(0, 12)
                    .map((i, index) => (
                      <div
                        key={index}
                        className="dashboard_drsecure_second_item_box_child_item"
                      >
                        <div className="dashboard_drsecure_second_item_box_child_item_detail">
                          <div>{index + 1}.</div>
                          <div>{i.name}</div>
                        </div>
                        <div>{i.value}</div>
                      </div>
                    ))
                ) : (
                  <NoRecord />
                )}
              </div>
            </div>
          </div>
        )
      ) : (
        <NoPermission />
      )}
    </div>
  );
};
